export default "__VITE_ASSET__bacc5357__"